import { Modal, Button, Form } from 'react-bootstrap';
import { useState } from 'react';
import { TemplatesModel } from 'types';
import { useTranslation } from 'react-i18next';

type Props = {
  template: TemplatesModel;
  show: boolean;
  onClose: () => void;
  onSave: (guid: string, days: number) => void;
};

export default function ExpiryDaysModal({
  template,
  show,
  onClose,
  onSave
}: Props) {

  const { t } = useTranslation('mailManager');
  const [days, setDays] = useState<string>(
    template.expiryWarningDays?.toString() ?? '90'
  );

  return (
    <Modal show={show} onHide={onClose} centered size="sm">
      <Modal.Header closeButton>
        <Modal.Title>
          {t('expiry_days_title')}
        </Modal.Title>

      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>
            {t('expiry_days_label')}
          </Form.Label>

          <Form.Control
            type="number"
            min={1}
            max={365}
            value={days}
            onFocus={e => e.target.select()}
            onChange={e => setDays(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        
        <Button variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>

        <Button
          variant="primary"
          onClick={() => {
            const numeric = Number(days);
            if (!numeric || numeric < 1) return;
            onSave(template.guid, numeric);
          }}
        >
          {t('save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}